import { gql, TypedDocumentNode } from '@common/hooks';
import { RoleType } from '@clinician-profile/graphql/types';

export const RolesQuery: TypedDocumentNode<RolesResponse, RolesVariables> = gql`
  query Roles($ids: [String!], $organizationUnitId: ID) {
    roles(ids: $ids, organizationUnitId: $organizationUnitId) {
      id
      name
      abbreviation
      suggested
    }
  }
`;

export type RolesResponse = {
  roles: RoleType[];
};

export type RolesVariables = {
  ids?: string[];
  organizationUnitId?: string;
};
